import React, { useState, useEffect } from "react";
import {
  Modal,
  Backdrop,
  Fade,
  Box,
  Button,
  Grid,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AdjuntoComentario from "./AdjuntoComentario";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import AddCircleIcon from "@material-ui/icons/AddCircle";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 6),
    borderRadius: "8px",
    outline: "none",
    width: "600px",
    overflowY: "auto", // Habilita el scroll vertical
    maxHeight: "90vh", // Limita la altura del contenedor
    padding: "16px", // Asegura un espacio adecuado
  },
  fileInput: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  btnAceptar: {
    backgroundColor: "#4d90fe",
    margin: "5px",
    color: "#000",
    "&:hover": {
      backgroundColor: "#357ae8",
    },
  },
  btnCancelar: {
    backgroundColor: "gray",
    margin: "5px",
    color: "#000",
    "&:hover": {
      backgroundColor: "#CCCCCC",
    },
  },
  elementosAlFinal: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "end",
    alignItems: "flex-end",
  },
}));

const ModalAdjuntosComentario = ({
  adjuntoComentario,
  onClose,
  tarjeta,
  setCargando,
  setMensaje,
  setAdjuntoComentario,
  isEdit
}) => {
  const classes = useStyles();

  const adjuntarArchivos = () => {
    let isValid = true;
    adjuntoComentario?.files?.map((archivo)=>{
      if (archivo.data == null) {
        isValid = false;
        return;
      }
    });

    if (isValid)
      setAdjuntoComentario({
        open: false,
        files: [...(adjuntoComentario?.files || [])],
      });
    else
      setMensaje({ open: true, status: -1, value: 'Selecciona todos los archivos.' });
  }

  return (
    <Modal
      open={Boolean(adjuntoComentario?.open)}
      onClose={onClose}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={Boolean(adjuntoComentario?.open)}>
        <Box
          className={classes.paper}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Grid container>
            <Grid item xs={12}>
              <Typography style={{ color: "#CCCCCC" }}>
                {"Archivos adjuntos de comentario"}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {adjuntoComentario?.files?.map((fileAdjunto, index) => (
                <AdjuntoComentario
                  fileAdjunto={fileAdjunto}
                  key={index}
                  index={index}
                  adjuntoComentario={adjuntoComentario}
                  setAdjuntoComentario={setAdjuntoComentario}
                />
              ))}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="filled"
                onClick={() =>
                  setAdjuntoComentario({
                    ...adjuntoComentario,
                    files: [
                      ...(adjuntoComentario?.files || []),
                      { data: null },
                    ],
                  })
                }
              >
                <AddCircleIcon />
              </Button>
            </Grid>
            <Grid item xs={12} className={classes.elementosAlFinal}>
              <Button
                variant="filled"
                onClick={() => setAdjuntoComentario({ open: false, files: [] })}
                className={classes.btnCancelar}
              >
                {isEdit ? 'Cancelar' : 'Limpiar'}
              </Button>
              <Button
                variant="filled"
                onClick={adjuntarArchivos}
                className={classes.btnAceptar}
              >
                Adjuntar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Fade>
    </Modal>
  );
};

export default ModalAdjuntosComentario;
